import React from 'react';
import PropTypes from 'prop-types';


function CarouselImage({ text, imageName }) {
  return (
    <img
      className="block h-full w-full object-contain"
      src={`/profile/${imageName}`}
      alt={text}
    />
  );
}

CarouselImage.propTypes = {
  text: PropTypes.string.isRequired, // Describes the slide
  imageName: PropTypes.string.isRequired, // Name of the image file in the public/profile folder
};

export default CarouselImage;
